// extracted by mini-css-extract-plugin
module.exports = {"modal-box":"ix","modalBox":"ix","modal-mask":"iy","modalMask":"iy","close-btn":"iz","closeBtn":"iz","container":"iA","content":"iB","title":"iC","subTitle":"iD","detail":"iE"};